import { Plus } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";

const allowances = [
  "Basic",
  "HRA",
  "Dearness Allowance",
  "Special Allowance",
  "Conveyance Allowance",
  "Medical Allowance",
  "Leave Travel Allowance",
  "Food Allowance",
  "Uniform Allowance",
  "Education Allowance",
  "Transport Allowance",
  "Telephone Allowance",
];

export function AllowanceDropdown({ setEarnings, earnings }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const filteredAllowances = allowances.filter((allowance) =>
    allowance.toLowerCase().includes(searchTerm.toLowerCase())
  );
  useEffect(() => {
    function handleOutsideClick(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="text-sm text-[#27004a] font-semibold flex items-center mt-[4px] justify-center gap-1"
      >
        <Plus className="w-4 h-4" />
        Add Allowance
      </button>
      {isOpen && (
        <div className="absolute z-10 mt-2 w-64 rounded-md shadow-lg bg-white ">
          <div className="p-2">
            <input
              type="text"
              placeholder="Search allowances"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none "
            />
          </div>
          <ul className="max-h-60 overflow-auto py-1">
            {filteredAllowances.map((allowance, index) => (
              <li
                key={index}
                className="px-4 py-2 hover:bg-gray-100 text-sm font-light cursor-pointer"
                onClick={() => {
                  // Check if the allowance is already added
                  if (
                    !earnings?.some((earning) => earning?.name === allowance)
                  ) {
                    setEarnings([
                      ...earnings,
                      { name: allowance, amount: "", type: "On Attendance" },
                    ]);
                    setIsOpen(false);
                  }
                }}
              >
                {allowance}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
